import { useQuery } from '@tanstack/react-query';
import type { InstancesResponse } from '../gen/openapi';
import { useApiClient } from './useApiClient';

export const useInstances = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { instances } = useApiClient();

  return useQuery<InstancesResponse, Error>({
    queryKey: ['instances'],
    queryFn: () => instances.getInstancesApiV1InstancesGet(),
    initialData: { instances: [] },
    enabled,
  });
};
